<template>
    <div class="signup-nav-bar">
        <a class="header-link" title="Home" @click="gotoHome" v-if="signupStep === 2">
						<img class="icon-header" :src="homeIcon"/>
        </a>
        <primary-button class="btn-signup-nav" @click="handleClickBack" v-if="isBackButtonVisible">Back</primary-button>
		<a v-else></a>
        <primary-button 
          v-if="shouldShowSignupNavButtons"
          @click="handleClickSkip" 
          id="skip-signup-step"
          class="btn-signup-nav" 
        >Skip</primary-button>
        <step-progress-bar class="signup-progress" :stepTitle="signupTitle" :step="realSignupStep" :stepCount="totalStepCount"/>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import PrimaryButton from '../PrimaryButton.vue';
import StepProgressBar from '../StepProgressBar.vue';
import {saveState} from '../../localstorage';
import {enums, BASE_PATH} from 'config';
import {shouldShowCreatingClass, shouldShowPricing} from '../../signup/signup_helpers';
import {finishSignUpFlow}  from '../../signup/sign_up_utils';
import {getUserRole} from 'common/UserService';

export default {
  components: {
    PrimaryButton,
    StepProgressBar
  },
  props: {
    signupTitle: String,
    signupStep: Number,
    homeIcon: String,
    shouldShowSignupNavButtons: Boolean,
    isStudentNav: Boolean
  },
  computed: {
	...mapState('teacher', ['isSchoolPageRedirected']),
	totalStepCount() {
    const signUpStepsCount = enums.signUpStepsCount;
    if (shouldShowCreatingClass()) {
      return shouldShowPricing() ? signUpStepsCount.TEACHER_WITH_INVITE_AND_PRICING : signUpStepsCount.TEACHER_WITH_PRICING;
    } else {
      return shouldShowPricing() ? signUpStepsCount.TEACHER_WITH_PRICING : signUpStepsCount.TEACHER_WITHOUT_PRICING;
    }
	},
  realSignupStep() {
    if (shouldShowCreatingClass() || this.signupStep < enums.signUpStatus.PRICING) {
      return this.signupStep;
    } else {
      return this.signupStep - 1;
    }
  },
  isBackButtonVisible() {
    const signupStatus = enums.signUpStatus;
    const isClassroomPageVisible = shouldShowCreatingClass();
    return this.shouldShowSignupNavButtons && !this.isSchoolPageRedirected && (!isClassroomPageVisible || (isClassroomPageVisible && this.signupStep !== signupStatus.PRICING));
  }
  },
  methods: {
    ...mapMutations('teacher', ['updateSignupStatus', 'updateSchoolInfo', 'updateSchoolInfoSkipped' , 'updateSignupABTest']),
    refreshSignupState() {
      this.updateSignupStatus(null);
      this.updateSignupABTest(null);
      saveState(this.$store.state);
    },
    gotoHome() {
      this.refreshSignupState();
      this.$router.push('/');
      location.reload();
    },
    showCreateClassPage() {
      this.updateSignupStatus(enums.signUpStatus.CREATE_CLASS);
      saveState(this.$store.state);
      this.$emit('stepCompleted', 'create-classroom');
    },
	showPricingPage() {
	  this.updateSignupStatus(enums.signUpStatus.PRICING);
	  saveState(this.$store.state);
    this.$emit('stepCompleted', 'signup-pricing');
	},
	showClassListPage() {
	  this.refreshSignupState();
    this.updateSchoolInfo(null);
    finishSignUpFlow(getUserRole());
	  history.replaceState(null, 'My Classes', BASE_PATH+'/app/teacher/class/list');
	  location.reload();
	},
    handleClickBack() {
      this.$router.go(-1);
      if (this.realSignupStep > enums.signUpStatus.UPDATE_INFO) {
        this.updateSignupStatus(this.realSignupStep - 1);
      }
    },
    handleClickSkip() {
	  this.updateSchoolInfoSkipped(true);
    const isNextStepVisible = shouldShowCreatingClass() || shouldShowPricing();
	  if (this.signupStep === enums.signUpStatus.SCHOOL_INFO && !this.isSchoolPageRedirected && isNextStepVisible) {
      if (shouldShowCreatingClass()) {
        this.showCreateClassPage();
      } else {
        this.showPricingPage();
      }
	  } else if (this.signupStep === enums.signUpStatus.CREATE_CLASS && shouldShowPricing()) {
      this.showPricingPage();
	  } else {
		this.showClassListPage();
	  }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../variables';

.signup-nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  max-width: $signup-navbar-w;
  height: $signup-navbar-h;
  background: $light-blue8;
  margin: 0 auto;
  .header-link {
    cursor: pointer;
  }
  .btn-signup-nav {
    background: $light-blue8;
    padding: 15px 32px;
    color: $light-blue2;
    border-color: $light-blue9;
    border-radius: 32px;
    &:hover {
      border-color: rgba(164, 197, 252, 0.7);
      color: rgba(73, 139, 249, 0.7);
    }
  }
  .signup-progress {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 1170px) {
    padding: 0 20px;
  }

  @media (max-width: 767px) {
    .header-link {
      .icon-header {
        width: $signup-mobile-headericon-w;
      }
    }
  }
  @media (max-width: 450px) {
    .btn-signup-nav {
      height: auto;
      padding: 0;
      border: 0;;
    }
  }
}

</style>